// Template Generated by DataExtraction.py at 1717541024
        
import ADULTCLBEnglish2 from "../../Forms/CESG/ADULTCLB_English2.png";
import ADULTCLBEnglish2Labels from "../../Labels/CESG/ADULTCLB_English2.json";
import ADULTCLBFrench2 from "../../Forms/CESG/ADULTCLB_French2.png";
import ADULTCLBFrench2Labels from "../../Labels/CESG/ADULTCLB_French2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ADULTCLBFrench2Labels : ADULTCLBEnglish2Labels;
    const formImage = isFrench ? ADULTCLBFrench2 : ADULTCLBEnglish2;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */


    const format = "YYYY-MM-DD";

    const subscriber = data.subscriber;
    const now = moment().format(format);
    const subscriber2Include = data.common.subscriber2Include;

    const jointSubscriber = data.jointSubscriber;
    const beneficiary = data.beneficiary;

    let pcgSin;

    if (subscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        pcgSin = jointSubscriber.sin;
    } else {
        pcgSin = "";
    }

    let isIndependant = pcgSin === beneficiary.sin;

    if (!isIndependant) {

        // Drawing the form
        // TODO implement fields
        drawText(subscriber.firstName, "subscriber1FirstName");
        drawText(subscriber.lastName, "subscriber1LastName");
        drawText(now, "subscriber1SignDateYyyyMmDd");
        if (subscriber2Include) {
            drawText(jointSubscriber.firstName, "subscriber2FirstName");
            drawText(jointSubscriber.lastName, "subscriber2LastName");
            drawText(now, "subscriber2SignDateYyyyMmDd");
        }
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ADULTCLBFrench2Labels : ADULTCLBEnglish2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];

    const subscriber = state.subscriber;
    const subscriber2Include = state.common.subscriber2Include;

    const jointSubscriber = state.jointSubscriber;
    const beneficiary = state.beneficiary;

    let pcgSin;

    if (subscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        pcgSin = jointSubscriber.sin;
    } else {
        pcgSin = "";
    }


    let isIndependant = pcgSin === beneficiary.sin;

    if (!isIndependant) {

        // subscriber1Signature
        signers.push({
            [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("subscriber1Signature", labels))],
        });

        if (subscriber2Include) {
            // subscriber2Signature
            signers.push({
                [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("subscriber2Signature", labels))],
            });
        }

    }

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    
